import styled from "styled-components";

import { ProposalsOrientationStyleProps } from "./types";

import VoteGroup from "./VoteGroup";

export const Wrapper = styled.div`
    margin-top: 7px;
`;

export const StyledProposals = styled(
    VoteGroup,
)<ProposalsOrientationStyleProps>`
    display: ${(props) =>
        "horizontal" === props.$proposalsOrientation ? "flex" : null};
    gap: ${(props) =>
        "horizontal" === props.$proposalsOrientation ? "8px" : null};
`;
